import React, { Component } from 'react'
import { TxBottom } from '../../../../components'

class TokenEvents extends Component {
    render() {
        return <TxBottom {...this.props} />
    }
}

export default TokenEvents
